import React from 'react';
import { IconMap } from '@components/icons/icon-map';
import { IconTime } from '@components/icons/icon-time';
import { OptimizedImage } from '@components/optimized-image';
import { headerDateFormat } from '@utils/event-report/header-date-format';

import { EventSummaryCardProps } from './event-summary-card.type';

export const EventSummaryCard = ({
  startingTime,
  name,
  coverUrl,
  clubName,
  locale,
  timezone,
}: EventSummaryCardProps) => {
  return (
    <div className='w-full py-3 pl-4 pr-6 mb-2 sm:py-4 sm:mb-4 bg-surface-secondary rounded-lg justify-start xs:items-center gap-4 inline-flex'>
      <div className='w-16 h-16 relative shrink-0'>
        <OptimizedImage alt={name} width={120} height={120} src={coverUrl} className='rounded-lg' />
      </div>
      <div className='flex-col gap-1 inline-flex overflow-x-hidden'>
        <h3 className='text-headline-s text-primary line-clamp-2'>{name}</h3>
        <div className='flex gap-2 items-center flex-wrap'>
          <p className='flex gap-1 items-center text-subtitle-s text-primary overflow-x-hiddenn'>
            <IconMap className='-mt-0.5 w-5 h-5 shrink-0' />
            <span className='truncate'>{clubName}</span>
          </p>
          <p className='flex gap-1 items-center text-subtitle-s text-primary'>
            <IconTime className='-mt-0.5 w-5 h-5' />
            <span className='whitespace-nowrap'>{headerDateFormat(startingTime, locale, timezone)}</span>
          </p>
        </div>
      </div>
    </div>
  );
};
